export default __webpack_public_path__ + "static/media/su-logo-dark.625f8c70.svg";